import QuestionHeader from './QuestionHeader'
import QuestionItemContainer from './QuestionItemContainer'

interface ParagraphQuestionProps {
  mark: number
  time: number
  question: string
  createdAt: string | number
  question_id: number
  questionType: string
  cantEdit?: boolean
  in_pt?: boolean
  section: string
  questionInfo: string
  onClick?: () => void
  onDeleteSuccess?: () => void
}

const ParagraphQuestion = ({
  mark,
  time,
  question,
  question_id,
  questionType,
  createdAt,
  cantEdit,
  in_pt,
  section,
  questionInfo,
  onClick,
  onDeleteSuccess,
}: ParagraphQuestionProps) => {
  return (
    <QuestionItemContainer time={time} score={mark} onClick={onClick}>
      <QuestionHeader
        section={section}
        questionInfo={questionInfo}
        cantEdit={cantEdit}
        in_pt={in_pt}
        question_id={question_id}
        questionType={questionType}
        createdAt={createdAt}
        onDeleteSuccess={onDeleteSuccess}
      />
      <p className='mt-2 text-left text-[#002652]'>{question}</p>
    </QuestionItemContainer>
  )
}

export default ParagraphQuestion
